import { Button, Checkbox, FormControlLabel, Icon, Tooltip } from "@material-ui/core";
import DataSearchBar from "components/DataSearchBar";
import { useGetClientsWithConfigsQuery } from "features/clients/clientConfigSlice";
import { useGetLotsQuery } from "features/lots/lotSlice";
import { getLotsWithTenantText } from "features/lots/lotUtil";
import { hasAccessToAllClients, selectIsClient, selectTenantName } from "features/user/userSlice";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import FilterService from "services/filterService";
import {
    useGetAllActivityItemsWithCustomFieldsQuery,
    useGetAllActivityTypesQuery
} from "../../../features/activity/activitySlice";
import { useGetVehicleTypeCategoryQuery, useGetVehicleTypesQuery } from "../../../features/vehicles/vehicleSlice";
import { tableFiltersStyle } from "./style";

const ListFilter = ({ values, value, onChangeValue, multiple, identifier, renderOption, grouped }) => {
    const classes = tableFiltersStyle();
    const [showMore, setShowMore] = useState(false);
    const [searchVal, setSearchVal] = useState('');
    const [expandedGroups, setExpandedGroups] = useState({});
    const sortedValues = values?.slice()?.sort((a, b) => {
        if (a.pinTop && !b.pinTop) return -1;
        if (!a.pinTop && b.pinTop) return 1;
        if (a.pinTop && b.pinTop) return 0;
        if (a.id === null && b.id !== null) return 1;
        if (a.id !== null && b.id === null) return -1;
        return a?.name?.localeCompare(b?.name);
    });
    const filteredValues = FilterService.filter([], searchVal, sortedValues ?? [], []);
    const allChecked = filteredValues?.length > 0 && filteredValues?.every(v => (Array.isArray(value) ? value.includes(v.id) : false));

    const toggleGroup = (groupId) => {
        setExpandedGroups(prev => ({
            ...prev,
            [groupId]: !prev[groupId]
        }));
    };

    const selectAllOptions = (isChecked) => {
        if (isChecked) {
            if (grouped) {
                const allIds = filteredValues?.map(v => v.options?.map(o => o.id)).flat();
                onChangeValue(allIds, identifier);
            } else {
                const allIds = filteredValues.map(v => v.id);
                onChangeValue(allIds, identifier);
            }
        } else {
            onChangeValue([], identifier);
        }
    };

    const selectAllGroupOptions = (group, isChecked) => {
        const allIds = group?.options.map(v => v.id) ?? [];

        if (isChecked) {
            const newValues = Array.isArray(value) ? [...new Set([...value, ...allIds])] : allIds;
            onChangeValue(newValues, identifier);
        } else {
            const newValues = (Array.isArray(value) ? value : []).filter(v => !allIds.includes(v));
            onChangeValue(newValues, identifier);
        }
    };

    const renderGroup = (group) => (
        <div key={group.id}>
            <div className={classes.groupHeader} onClick={() => toggleGroup(group.id)}>
                {group.name}
                <Icon className={classes.icon}>
                    {expandedGroups[group.id] ? 'expand_less' : 'expand_more'}
                </Icon>
            </div>
            {expandedGroups[group.id] && group.options.length > 1 && <div className={classes.radioLabel}>
                <FormControlLabel
                    control={<Checkbox
                        checked={group.options?.length > 0 && group.options?.every(v => (Array.isArray(value) ? value.includes(v.id) : false))}
                        onChange={(e, value) => selectAllGroupOptions(group, value)}
                        className={classes.checkbox}
                        size="small"
                    />}
                    label={<label className={classes.radioName}>Select All</label>}
                />
            </div>}
            {expandedGroups[group.id] && group.options.map(val => multiple ?

                <MultipleFilter
                    key={val.id}
                    val={val}
                    filterValue={value}
                    onChangeValue={onChangeValue}
                    identifier={identifier}
                    renderOption={renderOption}
                />
                :
                <SingleFilter
                    key={val.id}
                    val={val}
                    filterValue={value}
                    onChangeValue={onChangeValue}
                    identifier={identifier}
                />
            )}
        </div>
    );

    return (
        <>
            <div className={classes.filter}>
                {sortedValues?.length > 10 &&
                    <DataSearchBar
                        rows={filteredValues}
                        onSearch={(val) => setSearchVal(val)}
                        searchVal={searchVal}
                    />
                }
                {filteredValues?.length > 1 && multiple && <div className={classes.radioLabel}>
                    <FormControlLabel
                        control={<Checkbox
                            checked={allChecked}
                            onChange={(e, value) => selectAllOptions(value)}
                            className={classes.checkbox}
                            size="small"
                        />}
                        label={<label className={classes.radioName}>{grouped ? 'Select All In Groups' : 'Select All'}</label>}
                    />
                </div>}
                {(showMore ? filteredValues : filteredValues.slice(0, 10))?.map(val => (
                    grouped ? renderGroup(val) :
                        multiple ?
                            <MultipleFilter
                                key={val.id}
                                val={val}
                                filterValue={value}
                                onChangeValue={onChangeValue}
                                identifier={identifier}
                                renderOption={renderOption}
                            /> :
                            <SingleFilter
                                key={val.id}
                                val={val}
                                filterValue={value}
                                onChangeValue={onChangeValue}
                                identifier={identifier}
                            />
                ))}
            </div>
            {filteredValues?.length > 10 &&
                <Button color="primary" onClick={() => setShowMore(!showMore)} className={classes.showMoreBtn}>
                    {showMore ? "Show less" : "Show more"}
                </Button>
            }
        </>
    );
};



const SingleFilter = ({ val, filterValue, onChangeValue, identifier }) => {
    const classes = tableFiltersStyle();

    return (
        <div className={classes.radioLabel}>
            <input className={classes.radioButton} type="radio" checked={filterValue == val.id} onChange={() => onChangeValue(val.id, identifier)} />
            <label className={classes.radioName}>{val.name}</label>
        </div>
    );
};

const MultipleFilter = ({ val, filterValue, onChangeValue, identifier, renderOption }) => {
    const classes = tableFiltersStyle();

    const onSelect = (value) => {
        let valueList = filterValue || [];
        valueList = Array.isArray(filterValue) ? filterValue : filterValue !== undefined && filterValue !== null ? [filterValue] : [];
        valueList = valueList?.filter(v => v !== undefined && v !== null) ?? [];
        if (value) {
            valueList = [...(valueList ?? []), val.id];
        } else {
            valueList = valueList.filter(v => v != val.id);
        }
        onChangeValue(valueList?.length > 0 ? valueList : null, identifier);
    }

    return (

        <div className={classes.radioLabel}>
            <FormControlLabel
                control={<Checkbox
                    checked={Array.isArray(filterValue) ? filterValue?.includes(val.id) : filterValue === val.id}
                    onChange={(e, value) => onSelect(value)}
                    className={classes.checkbox}
                    size="small"
                />}
                label={renderOption ? renderOption(val) : <label className={classes.radioName}>{val.name}</label>}
            />
        </div>
    );
};

export const LotsFilter = ({
    identifier,
    onSelect,
    clientId,
    value,
    multiple,
    ownedByTenant,
    newLots = []
}) => {

    const classes = tableFiltersStyle();

    const tenantName = useSelector(selectTenantName);

    let { data: clientsWithConfigs, error: error, isLoading: isLoading } = useGetClientsWithConfigsQuery(null);
    let { data: getLots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    const clientsConfigs = clientsWithConfigs?.find(c => c.id == clientId);
    let lots = !clientsConfigs?.clientLots ? getLots : getLots?.filter(lot => clientsConfigs?.clientLots?.find(l => l.lotId == lot.id));
    lots = ownedByTenant ? lots?.filter(lot => lot.ownedByTenant) : lots;
    lots = (lots && newLots) ? [...(lots ?? []), ...newLots] : lots;

    const [onlyTenantLots, setOnlyTenantLots] = useState(true);

    const getCorrectLots = (lots) => {
        if (!onlyTenantLots) return getLotsWithTenantText(lots, tenantName) ?? [];
        let lotsFiltered = (lots ?? [])?.filter((lot) => lot?.ownedByTenant == onlyTenantLots);
        return getLotsWithTenantText(lotsFiltered, tenantName) ?? [];
    }

    return (<>
        <div className={classes.radioLabel}>
            <FormControlLabel
                control={<Checkbox
                    checked={onlyTenantLots}
                    onChange={(e, value) => setOnlyTenantLots(value)}
                    className={classes.checkbox}
                    size="small"
                />}
                label={<label className={classes.radioName}>Show {tenantName} lots only</label>}
            />
        </div>
        <ListFilter
            values={getCorrectLots(lots)}
            value={value}
            onChangeValue={onSelect}
            multiple={multiple}
            identifier={identifier}
        />
    </>
    );
};

export const AssetStatusFilter = ({
    identifier,
    onSelect,
    values,
    value,
    multiple,
}) => {
    const classes = tableFiltersStyle();
    let isClient = useSelector(selectIsClient);
    let hasFullAccess = useSelector(hasAccessToAllClients);

    let noLabelValues = values?.map(status => ({
        ...status,
        aliasLabel: status?.alias ? status?.label : '',
        label: status?.alias ? '' : status?.label
    }));

    if (hasFullAccess) {
        // Remove duplicate status items by their id, keeping the last occurrence
        noLabelValues = Array.from(new Map(noLabelValues.map(item => [item.id, item])).values());
    }

    const renderOption = (value) => {
        return <>
            {value?.alias ?
                <>
                    <label className={classes.radioName}>{isClient ? value?.alias : value?.aliasLabel}</label>
                </>
                : <label className={classes.radioName}>{value?.name}</label>
            }
        </>
    }
    return (
        <ListFilter
            values={noLabelValues ?? []}
            value={value}
            onChangeValue={onSelect}
            multiple={multiple}
            identifier={identifier}
            renderOption={renderOption}
        />
    );
};


export const VehicleTypeListFilter = ({
    identifier,
    onSelect,
    value,
    multiple,
}) => {
    const { data: vehicleTypes, isLoading: isLoadingVehicleTypes } = useGetVehicleTypesQuery();
    const { data: vehicleTypeCategories, isLoading: isLoadingVehicleTypeCategory } = useGetVehicleTypeCategoryQuery();

    const handleSelectChange = (option) => {
        onSelect(option, identifier);
    };

    const combinedData = useMemo(() => {
        if (!vehicleTypes || !vehicleTypeCategories) return [];

        const sortedVehicleTypes = [...vehicleTypes].sort((a, b) => a.name.localeCompare(b.name));
        const sortedVehicleTypeCategories = [...vehicleTypeCategories].sort((a, b) => a.name.localeCompare(b.name));

        return sortedVehicleTypeCategories.map(type => ({
            name: type.name,
            id: type.id,
            options: sortedVehicleTypes
                .filter(item => item.vehicleTypeCategoryId === type.id)
                .map(item => ({ name: item.name, id: item.id }))
        }));
    }, [vehicleTypes, vehicleTypeCategories]);

    return (
        <>
            {!isLoadingVehicleTypeCategory && !isLoadingVehicleTypes && (
                <ListFilter
                    values={combinedData}
                    value={value}
                    onChangeValue={handleSelectChange}
                    multiple={multiple}
                    identifier={identifier}
                    grouped={true}
                />
            )}
        </>
    );
};

export const ActivityTypeListFilter = ({
    identifier,
    onSelect,
    value,
    multiple,
}) => {
    let { data: activityTypes, error: activityTypesError, isLoading: isLoadingActivityTypes } = useGetAllActivityTypesQuery();
    let { data: activityItemsWithCustomFields, error: activityItemError, isLoading: isLoadingActivityItems } = useGetAllActivityItemsWithCustomFieldsQuery();
    const handleSelectChange = (option) => {
        onSelect(option, identifier);
    };

    const combinedData = useMemo(() => {
        if (!activityTypes || !activityItemsWithCustomFields) return [];
        const sortedActivityTypes = [...activityTypes].sort((a, b) => a.name.localeCompare(b.name));
        const sortedActivityItems = [...activityItemsWithCustomFields].sort((a, b) => a.name.localeCompare(b.name));

        return sortedActivityTypes.map(type => ({
            name: type.name,
            id: type.id,
            options: sortedActivityItems
                .filter(item => item.activityTypeId === type.id)
                .map(item => ({ name: item.name, id: item.id }))
        }));
    }, [activityTypes, activityItemsWithCustomFields]);

    return (
        <>
            {!isLoadingActivityTypes && !isLoadingActivityItems && (
                <ListFilter
                    values={combinedData}
                    value={value}
                    onChangeValue={handleSelectChange}
                    multiple={multiple}
                    identifier={identifier}
                    grouped={true}
                />
            )}
        </>
    );
};
export default ListFilter;
